<div class="teranet-col">
    <div >
    <button type="button"  mat-button  (click)="onClose()" class="close" aria-label="Close">
        <div class="btntext">x</div>
    </button>    
    </div>
    <div mat-dialog-title class="teranet-row" *ngIf="Id!==-1">
        <h5>Edit {{clientFileForm.get("description").value}}</h5>
        <mat-divider></mat-divider>        
    </div>
    <div mat-dialog-title class="teranet-row" *ngIf="Id===-1">
        <h5>Create New Client File</h5>
        <mat-divider></mat-divider>        
    </div>
</div>

<div mat-dialog-content class="teranet-row">
    <div class="teranet-col" fxFlex.gt-sm="100" fxFlex="100">  
        <form [formGroup]="clientFileForm" #clientFileFormRef="ngForm" (ngSubmit)="createOrUpdateClientFileInfo(clientFileFormRef)">
               
            <div >
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>File Type</mat-label>
                    <mat-select required formControlName="filetypeid" (selectionChange)="filetypeselected($event)">
                        <mat-option *ngFor="let filetype of filetypes" [value]="filetype.id">{{filetype.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>File Name</mat-label> 
                    <input matInput placeholder="File Name" type="text" data-lpignore="true" formControlName="filename" name="filename">
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>File Extension</mat-label> 
                    <input matInput placeholder="File Extension" type="text" data-lpignore="true" formControlName="fileextension" name="fileextension">
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>SFTP Source Folder</mat-label>
                    <input matInput placeholder="SFTP Source Folder" type="text" data-lpignore="true" formControlName="sftpsourcefolder" name="sftpsourcefolder">                
                </mat-form-field>  
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>{{gettxt_SFTPFolder()}}</mat-label>
                    <input matInput placeholder={{gettxt_SFTPFolder()}} type="text" data-lpignore="true" formControlName="sftpdestinationfolder">
                  </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Minutes Between Checks</mat-label>
                    <input matInput placeholder="Minutes Between Checks" type="number" data-lpignore="true" formControlName="minutesbetweenchecks"  required>                       
                    <mat-error *ngIf="clientFileForm.get('minutesbetweenchecks').hasError('min')">
                        Please enter a number greater than 0
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Minutes to Wait</mat-label>
                    <input matInput placeholder="Minutes to Wait" type="number" data-lpignore="true" formControlName="minutestowait" required>                
                    <mat-error *ngIf="clientFileForm.get('minutestowait').hasError('min')">
                        Please enter a number greater than 0
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>SFTP Info</mat-label>
                    <mat-select formControlName="sftpinfoid">
                        <mat-option *ngFor="let sftpinfo of selectedSftp" [value]="sftpinfo.id">
                            {{sftpinfo.username}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>File Name Expression</mat-label>
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4" placeholder="File Name Expression" formControlName="filenameexpression"></textarea>
                  
                </mat-form-field>
                <mat-form-field class="col-md-8" appearance="outline">
                    <mat-label>File Description</mat-label>
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4" placeholder="Description" formControlName="description" required></textarea>                
                </mat-form-field>
                <mat-form-field class="col-md-4" appearance="outline" *ngIf="clientFileForm.get('filetypeid').value===10">
                    <mat-label>Parent File</mat-label>
                    <mat-select formControlName="clientfileid" >
                        <mat-option *ngFor="let clientfile of clientfiles" [value]="clientfile[0]">{{clientfile[1]}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div *ngIf="clientFileForm.get('filetypeid').value===1">
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Rejected Alert Threshold</mat-label>
                      <input matInput placeholder="Rejected Alert Threshold" type="number" min="0"
                        data-lpignore="true" formControlName="rejectedalertthreshold"
                      >                     
                      <mat-error *ngIf="clientFileForm.get('rejectedalertthreshold').hasError('min')">
                        Please enter a number greater than 0
                      </mat-error>
                      <mat-error *ngIf="clientFileForm.get('rejectedalertthreshold').hasError('max')">
                        Please enter a number less than 100
                      </mat-error>
                    </mat-form-field>
                    <mat-label *ngIf="clientFileForm.get('rejectedalertinpercent').value">%</mat-label>
                    <mat-checkbox class="col-md-4" formControlName="rejectedalertinpercent">Use Percentage
                    </mat-checkbox>
                </div>               
                <div>
                    <mat-checkbox class="col-md-4" (change)="ChoseAllSFTP($event)">
                      All SFTP Details</mat-checkbox>
                    <mat-checkbox class="col-md-4" formControlName="disableduplicatefilenamecheck">
                      Disable Duplicate Filename Check
                    </mat-checkbox>

                    <mat-checkbox class="col-md-4" formControlName="isenabled">Enable</mat-checkbox>
                </div>
                <div class="deletebtn">
                    <button mat-button type="submit" >   
                        <div class="btnicon">
                            <fa-icon icon="save" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
                        </div>                   
                        <div class="btntext">Save</div>
                    </button>
                </div>
            </div>       

        </form> 
    </div>

</div>

 
